/**
 * Pocketbase Configuration
 * 
 * This file contains environment-specific configuration for Pocketbase.
 * Use environment variables to switch between development and production.
 */

// Default to development if NODE_ENV is not set
const isDevelopment = process.env.NODE_ENV !== 'production';

// Configuration object with environment-specific settings
const pocketbaseConfig = {
  // Base API URL - can be overridden with environment variable
  apiUrl: process.env.REACT_APP_POCKETBASE_URL || 'https://pb03.uud.io',
  
  // Collection names - centralized for easy reference
  collections: {
    users: 'uud_onboard',
    socialLinks: 'social_links',
    userFavs: 'user_favs',
    userClicks: 'user_clicks',
    pageViews: 'page_views',
  },
  
  // Authentication settings
  auth: {
    tokenStorageKey: 'pb_auth',
    userStorageKey: 'currentUser',
    refreshInterval: 10 * 60 * 1000, // 10 minutes in milliseconds
  },
  
  // Request timeout in milliseconds
  timeout: 30000, // 30 seconds
  
  // Development-specific settings
  development: {
    enableLogging: true,
    mockResponses: false,
  },
  
  // Production-specific settings
  production: {
    enableLogging: false,
    mockResponses: false,
  },
};

// Export environment-specific configuration
export default {
  ...pocketbaseConfig,
  ...(isDevelopment ? pocketbaseConfig.development : pocketbaseConfig.production),
};